"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_1 = __importDefault(require("react"));
var DoubleCell_1 = __importDefault(require("containers/TableMaker/components/DoubleCell"));
var context_1 = __importDefault(require("../context"));
var AccessLevel = function (_a) {
    var _b;
    var item = _a.item;
    var companyId = react_1.default.useContext(context_1.default);
    return ((0, jsx_runtime_1.jsx)(DoubleCell_1.default, { main: companyId && ((_b = item.companyAccessLevel) === null || _b === void 0 ? void 0 : _b[companyId]) && end2end_1.ACC_LVL_MAPPER[item.companyAccessLevel[companyId]], secondary: companyId !== item.companyId && 'Not currently IN the company' }));
};
exports.default = AccessLevel;
